<template>
  <!-- 网吧用户管理 -->
  <div class="container">
    <!-- 管理员 -->
    <!-- <div class="user-list">
      <span class="user-head">
        <img src="@/images/userhead.png" alt srcset />
      </span>
      <span class="user-name">{{user.name}}</span>
      <span class="user-jurisdiction" v-show="user.isAdmin == 0">{{user.duty}}</span>
    </div> -->
    <!-- 普通人员 -->
    <div class="user-list" v-for="(item,index) in list" :key="index">
      <span class="user-head">
        <img src="@/images/userhead.png" alt srcset />
      </span>
      <span class="user-name">{{item.userName}}</span>
      <span class="user-jurisdiction" v-show="item.isAdmin == 0">管理员</span>
      <!-- 删除用户 -->
      <span class="user-del" @click="handleDelClick(item.id)" v-show="item.isAdmin !== 0">
        <img src="@/images/userdel.png" alt srcset />
      </span>
      <!-- 设置为管理员 -->
      <span class="user-set" @click="handleAdminClick(item.userId)"  v-show="item.isAdmin !== 0">
        <img src="@/images/userset.png" alt srcset />
      </span>
  
    </div>
    <!-- 添加人员 -->
    <div class="user-list">
      <span class="user-head">
        <img src="@/images/useradd.png" alt srcset />
      </span>
      <span class="user-name" @click="handleGoPageAddUser">添加人员</span>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
import { deleteUser } from "@/api/user";
import { CustomerUser,SetCustomerUser } from "@/api/customer";
export default {
  data() {
    return {
      user: "",
      list: [],
      isRouterAlive: true,
      isAdminId:''
    };
  },
  mounted() {
    this.requestUserList();
  },
  methods: {
    // 操作删除按钮
    handleDelClick(id) {
      Dialog.confirm({
        title: "确定删除该成员"
      })
        .then(() => {
          this.requestDeleteUser(id);
        })
        .catch(() => {
          // on cancel
        });
    },
    // 设置管理员
    handleAdminClick(userId) {
      Dialog.confirm({
        title: "确定将该成员设为管理员"
      })
        .then(() => {
          console.log(userId);
          this.requestSetCustomerUser(userId);
        })
        .catch(() => {
          // on cancel
        });
    },
    // 跳转到添加用户列表
    handleGoPageAddUser() {
      let netBarId  = this.$route.query.internetBarId
      this.$router.push({
        path: "/adduser",
        query:{
          netBarId:netBarId
        }
      });
    },
    // 获取用户列表
    requestUserList() {
      let netBarId  = this.$route.query.internetBarId
      CustomerUser({netBarId:netBarId}).then(res => {
        console.log(res);
        this.user = res.data.user;
        this.list = res.data.list;
        // for(var i = 0;i<res.data.list.length;i++) {
        //   console.log(i)
        // }
        res.data.list.forEach((element) => {
              if(element.isAdmin == 0) {
                 this.isAdminId = element.userId
              }
        });
      });
    },
    // 设置管理员
    requestSetCustomerUser(userId) {
        let isAdminId = this.isAdminId
        let netBarId  = this.$route.query.internetBarId
        SetCustomerUser({userId:isAdminId,userId1:userId,internetBarId:netBarId}).then(res=>{
          console.log(res)
          if(res.code == 200) {
             this.requestUserList();
          }
        })
    },
    // 删除用户
    requestDeleteUser(id) {
      deleteUser({ id: id }).then(res => {
        console.log(res);
        if (res.code == 200) {
          this.requestUserList();
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  overflow-x: hidden;
  .user-list {
    width: 350px;
    height: 60px;
    line-height: 60px;
    background-color: #ffffff;
    margin: 10px auto;
    border-radius: 8px;
    box-sizing: border-box;
    text-align: left;
    font-size: 15px;
    color: #333333;
    // 用户头像
    .user-head {
      display: inline-block;
      width: 40px;
      height: 40px;
      //  margin-top: 10px;
      margin-left: 10px;
      img {
        width: 40px;
        height: 40px;
        vertical-align: middle;
      }
    }
    // 用户名称
    .user-name {
      display: inline-block;
      vertical-align: middle;
      margin: 0 10px;
      font-weight: bold;
    }
    // 用户权限
    .user-jurisdiction {
      display: inline-block;
      width: 50px;
      height: 20px;
      line-height: 21px;
      background-color: rgba($color: #008cff, $alpha: 0.2);
      color: #008cff;
      border-radius: 10px;
      font-size: 12px;
      font-weight: bold;
      text-align: center;
      vertical-align: middle;
    }
    // 设置
    .user-set {
      float: right;
      width: 14px;
      height: 16px;
      margin-right: 15px;
      img {
        width: 14px;
        height: 16px;
      }
    }
    // 用户删除按钮
    .user-del {
      float: right;
      width: 14px;
      height: 16px;
      margin-right: 15px;
      img {
        width: 14px;
        height: 16px;
      }
    }
  }
  // 确定按钮
  .btn {
    width: 350px;
    height: 44px;
    background: -webkit-linear-gradient(left, #05aefc, #008cff);
    margin: 0 auto;
    border-radius: 22px;
    font-size: 16px;
    color: $white-color;
    line-height: 44px;
    margin: 0 auto;
    margin-top: 99px;
  }
}
</style>
